import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 8BA08E5C-7ED5-49E2-BDDE-1F1425C9FE1A
 * name arrow-right-box
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-box.svg
 * tags
 * - Arrow 
 */
export const ArrowRightBoxIcon = createSvgIcon(<><path d="M5,21A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5M6,13H14.5L11,16.5L12.42,17.92L18.34,12L12.42,6.08L11,7.5L14.5,11H6V13Z" /></>, 'ArrowRightBoxIcon');
export default ArrowRightBoxIcon